module.exports = __webpack_public_path__ + "img/ibmp-nasal-preparing-results.61f14eea.png";